import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion/'

import { TableHeader, TableRow, SearchFrame, SearchTable, SearchForm, FormContent } from '@front/squirtle'
import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import Callbacks from './callbacks'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const StepList = ({ record_id, ...props }) => {
  const filterToForm = useCallback(Callbacks.filterToFormHandler(), [])
  const formToFilter = useCallback(Callbacks.formToFilterHandler(record_id), [record_id])

  return <>
    <StepLabel>
      <Typography variant='h5'> {I18n.t('history.label', { count: 1 })} </Typography>
    </StepLabel>
    <StepContent >
      <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
        <SearchFrame
          model_name={'event'}
          populate={[
            'order',
            'driver.info',
            'order.assigned_transport',
            'operator.customerinfo',
            'operator.info',
            'driver.customerinfo',
            'driver.info'
          ]}
          allowCreate={false}
          default_limit={25}
          sort={['producedAt ASC']}
        >
          <SearchForm
            filterToForm={filterToForm}
            formToFilter={formToFilter}
            disableButton
            submitOnMount
          >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable
            tableProps={{
              onRowClick: _.noop
            }}
          >
            <TableHeader><Header /></TableHeader>
            <TableRow><Row /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Box>
    </StepContent>
  </>
}


export default React.memo(StepList)
